import { Progress, ProgressProps } from 'antd'

export interface KBProgressProps extends ProgressProps {}

export function KBProgress(props: KBProgressProps) {
  return <Progress {...props}></Progress>
}
